export const OCCUPATIONS: string[] = [
	"Unknown",
	"Architecture and Engineering Occupations" ,
	"Arts, Design, Entertainment, Sports, and Media Occupations" ,
	"Building and Grounds Cleaning and Maintenance Occupations" ,
	"Business and Financial Operations Occupations" ,
	"Community and Social Service Occupations" ,
	"Computer and Mathematical Occupations" ,
	"Construction and Extraction Occupations" ,
	"Education, Training, and Library Occupations" ,
	"Farming, Fishing, and Forestry Occupations" ,
	"Food Preparation and Serving Related Occupations" ,
	"Healthcare Practitioners and Technical Occupations" ,
	"Healthcare Support Occupations" ,
	"Installation, Maintenance, and Repair Occupations" ,
	"Legal Occupations" ,
	"Life, Physical, and Social Science Occupations" ,
	"Management Occupations" ,
	"Office and Administrative Support Occupations" ,
	"Personal Care and Service Occupations" ,
	"Production Occupations" ,
	"Protective Service Occupations" ,
	"Sales and Related Occupations" ,
	"Transportation and Material Moving Occupations"
]
export const INDUSTRIES: string[] = [
	"Unknown",
	"Accomodation and Food Services",
	"Admin and Support, Waste Management",
	"Agriculture, Forestry, Fishing and Hunting",
	"Arts, Entertainment, and Recreation",
	"Construction",
	"Educational Services",
	"Finance and Insurance",
	"Health Care and Social Assistance",
	"Information",
	"Management of Companies and Enterprises",
	"Manufacturing",
	"Mining",
	"Other Services (except Public Administration)",
	"Professional, Scientific, and Technical Services",
	"Public Administration",
	"Real Estate Rental and Leasing",
	"Retail Trade",
	"Transportation and Warehousing",
	"Utilities",
	"Wholesale Trade"
]